import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { setLink, useLink } from "../../utils/ClickedLink";
import { useState } from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [currentLink, setCurrentLink] = useState(useLink());

    const navigate = useNavigate();
  const handleLinkClick = (link, path) => {
      setLink(link);
      setCurrentLink(link);
      if (path) navigate(path);
      // setMobileMenuOpen(false); // close menu on mobile
      // setCountryDropdownOpen(false); // close dropdown
    };

    const handleSendEmail = () => {
      const to = "info@mambahikers.com";
      const subject = encodeURIComponent("Hello from My App");
      const body = encodeURIComponent(
        "Hi there,\n\nI wanted to reach out to you..."
      );

      const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}`;

      window.open(gmailUrl, "_blank");
    };

  return (
    <footer className="bg-gray-100 pt-16 pb-24 relative">
      <div className="flex flex-col md:flex-row justify-around p-12">
        {/* About Us */}
        <div className="md:w-2/5 mb-8 md:mb-0">
          <a
            href="/"
            target="_top"
            className="inline-block cursor-pointer mb-4"
          >
            <img src={logo} alt="logo" className="h-12" />
          </a>
          <h3 className="text-4xl font-semibold mb-4">
            Mamba Hikers Expeditions
          </h3>
          <p className="text-gray-600">
            At Mamba Hikers, we're not just about conquering peaks, we're about
            conquering yourself. Every summit we reach is a step towards
            rediscovering the wild spirit within. We're a tribe of adventure
            seekers, united by the rhythm of boots on dirt and the thrill of
            pushing beyond our limits.
          </p>
        </div>

        {/* Contacts */}
        <div className="md:w-1/4 mb-8 md:mb-0">
          <h3 className="text-4xl font-semibold mb-4">Get In Touch</h3>
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-center">
              <i className="fas fa-phone text-primary-700 pr-4"></i>
              <a href="tel:+254714818723" className="hover:text-primary-700">
                +254 714 818 723
              </a>
            </li>
            <li className="flex items-center">
              <i className="fas fa-envelope text-primary-700 pr-4"></i>
              <a
                href="mailto:info@mambahikers.com"
                className="hover:text-primary-700"
              >
                info@mambahikers.com
              </a>
            </li>
            <li className="flex items-center">
              <i className="fas fa-map-marker-alt text-primary-700 pr-4"></i>
              J's Arcade, Thome Outlet Number J28
            </li>
          </ul>

          {/* Social Media */}
          <div className="flex justify-between mt-6 w-4/5">
            <a
              href="https://www.facebook.com/mambahikers"
              target="_blank"
              rel="noreferrer"
              className="text-primary-700 hover:scale-110 transition-transform"
            >
              <i className="fab fa-facebook-f text-2xl"></i>
            </a>
            <a
              href="https://x.com/Mambahikers?t=zN1p261-8xzi5ERoSEFNoA&s=09"
              target="_blank"
              rel="noreferrer"
              className="text-primary-700 hover:scale-110 transition-transform"
            >
              <i className="fab fa-twitter text-2xl"></i>
            </a>
            {/* <a
              href="https://linkedin.com/in/yourprofile"
              target="_blank"
              rel="noreferrer"
              className="text-primary-700 hover:scale-110 transition-transform"
            >
              <i className="fab fa-linkedin-in text-2xl"></i>
            </a> */}
            <a
              href="https://www.instagram.com/mambahikers?igsh=MWNwZXQweDd6ODdoZg=="
              target="_blank"
              rel="noreferrer"
              className="text-primary-700 hover:scale-110 transition-transform"
            >
              <i className="fab fa-instagram text-2xl"></i>
            </a>
          </div>
        </div>

        {/* Useful Links */}
        <div className="md:w-1/4">
          <h3 className="text-4xl font-semibold mb-4">Useful Links</h3>
          <ul className="space-y-3 text-gray-700">
            <li
              className="hover:-translate-y-1 transition-transform cursor-pointer hover:text-primary-700"
              onClick={() => handleLinkClick("home", "/")}
            >
              Home
            </li>
            <li
              className="hover:-translate-y-1 transition-transform cursor-pointer hover:text-primary-700"
              onClick={() =>
                handleLinkClick("destinations", `/country/destinations/ke`)
              }
            >
              Destinations
            </li>
            <li
              className="hover:-translate-y-1 transition-transform cursor-pointer hover:text-primary-700"
              onClick={() => handleLinkClick("about-us", "/about-us")}
            >
              <a
                href="https://drive.google.com/file/d/1w1sjQbVp8HuSZW7vMiKsxRugIg5gYTpA/view?usp=sharing"
                target="_blank"
              >
                {" "}
                Our Policies
              </a>
            </li>
            <li className="hover:-translate-y-1 transition-transform cursor-pointer hover:text-primary-700">
              Shop With Us
            </li>
            <li
              className="hover:-translate-y-1 transition-transform cursor-pointer hover:text-primary-700"
              onClick={handleSendEmail}
            >
              Contact Us
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="absolute bottom-0 bg-color-primary-dark2 w-full py-4 text-white text-center">
        <p>
          &copy; {currentYear} Mamba Hikers Tours and Travel. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
